import React, { FunctionComponent } from 'react';

import { useParams } from 'react-router';

import { Translate } from 'react-localize-redux';

import styled from 'styled-components';

import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';
import ButtonArrow from '@components/actions/arrow-button';
import FormContainer from '@components/layout/form-container';

import TwoFactorInput from './input';
import PromptHint from './prompt-hint';

interface TwoFactorPromptPageProps {
  className?: string;
}

const TwoFactorPromptPage: FunctionComponent<TwoFactorPromptPageProps> = ({
  className,
}) => {
  const { type } = useParams<{ type: string }>();

  // TODO: DEVTEAM-845 - Integrate resend error
  const hasResendError = false;

  // TODO: DEVTEAM-845 - Integrate with validation code
  const buttonDisabled = false;

  // TODO: DEVTEAM-845 - Integrate resend code
  const handleResendCode = () => {
    return;
  };

  return (
    <FormContainer className={className || ''}>
      <Title type="subheader" customFont="semi-bold">
        <Translate id="2FA.PROMPT.TITLE" />
      </Title>
      <Flex alignItems="center" justifyContent="space-between" gap={10}>
        <InputContainer>
          <TwoFactorInput value={1} />
          <TwoFactorInput />
          <TwoFactorInput />
          <TwoFactorInput />
          <TwoFactorInput />
          <TwoFactorInput />
        </InputContainer>
        <ButtonArrow className="button-arrow" disabled={buttonDisabled} />
      </Flex>
      <PromptHint
        className="mt-20"
        title={
          <Translate
            id={
              type === 'authenticator'
                ? '2FA.PROMPT.HINT.AUTHENTICATOR.TITLE'
                : hasResendError
                ? '2FA.PROMPT.HINT.ERROR.TITLE'
                : '2FA.PROMPT.HINT.TITLE'
            }
          />
        }
        text={
          <Translate
            id={
              type === 'authenticator'
                ? undefined
                : hasResendError
                ? '2FA.PROMPT.HINT.ERROR.TEXT'
                : '2FA.PROMPT.HINT.TEXT'
            }
          />
        }
        action={
          type === 'authenticator' ? undefined : (
            <Translate id="2FA.PROMPT.HINT.ACTION" />
          )
        }
        onClick={handleResendCode}
        isError={hasResendError && type !== 'authenticator'}
      />
      <Separator />
      <Link className="mt-40" type="small">
        <Translate id="2FA.PROMPT.HELP" />
      </Link>
    </FormContainer>
  );
};

export default styled(TwoFactorPromptPage)`
  .button-arrow {
    height: 125px;
    @media ${({ theme }) => theme.device.laptopL} {
      height: auto;
    }
  }
`;

const Title = styled(Typography)`
  margin-top: 24px;
  margin-bottom: 20px;
  @media ${({ theme }) => theme.device.tablet} {
    margin-top: 80px;
    margin-bottom: 30px;
  }
`;

const InputContainer = styled.div`
  display: grid;
  grid-gap: 5px;
  grid-template-columns: repeat(auto-fit, minmax(70px, 1fr));
  width: 100%;
  @media ${({ theme }) => theme.device.laptopL} {
    width: calc(100% - 78px);
    grid-template-columns: repeat(6, 1fr);
  }
`;

const Link = styled(Typography)`
  cursor: pointer;
  opacity: 1;
  text-align: center;
  transition: opacity
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};

  &:hover {
    opacity: 0.75;
  }

  @media ${({ theme }) => theme.device.laptopL} {
    text-align: left;
  }
`;

const Separator = styled.span`
  width: 100%;
  height: 1px;
  margin-top: 1px;
  display: block;
  margin-top: 20px;
  background-color: ${({ theme }) => theme.colors.headerBorder};
  @media ${({ theme }) => theme.device.laptopL} {
    display: none;
  }
`;
